import {
  getEnumFromValueType,
  IRRIGATION_APPLIED_VOLUME_VALUE_TYPE_PREFIX,
} from '@semios/app-platform-values-helpers-and-types'
import { isPrePostFilterEmitterType } from 'utils/isPrePostFilterEmitterType'

// Matches the Hub's own Pressure Sensors table (SummaryGridTable pressureSensorsActivity): an
// applied-volume value type whose emitter is a real emitter. Pre-filter and post-filter emitters
// measure the filter stack rather than water delivered to the block, so counting them would add
// device rows and inflate volumes against the Hub table the dashboards reconcile with.
export const isPressureSensorValueType = (valueType: string): boolean => {
  if (!valueType.includes(IRRIGATION_APPLIED_VOLUME_VALUE_TYPE_PREFIX)) return false

  const emitterType = getEnumFromValueType(valueType)

  return !!emitterType && !isPrePostFilterEmitterType(emitterType)
}
